import { ColumnDef } from "@tanstack/react-table"
import { Box, Chip } from "@mui/material"
import { getDisplayPrice } from "src/shared/utils/helpers-functions"
import { getLotStatusIcon, getLotStatusColor, getLotStatusLabel } from "./lotStatusHelpers"

export const getProductLotsColumns = (): ColumnDef<any>[] => [
  {
    accessorKey: "actionId",
    header: "Action ID",
    enableColumnFilter: false,
    enableSorting: false,
    cell: ({ row }) => {
      return (
        <Box display="flex" alignItems="center" gap={1}>
          {getLotStatusIcon(row.original.status)}
          <Box>
            <Box component="span" fontWeight="medium">
              {row.original.actionId}
            </Box>
            <Chip
              label={getLotStatusLabel(row.original.status)}
              size="small"
              color={getLotStatusColor(row.original.status) as any}
              variant="outlined"
              sx={{ ml: 1 }}
            />
          </Box>
        </Box>
      )
    }
  },
  {
    accessorKey: "expectedQuantity",
    header: "Expected Qty",
    enableColumnFilter: false,
    enableSorting: false,
    cell: ({ row }) => (
      <Box textAlign="right" fontWeight="medium">
        {getDisplayPrice(row.original.expectedQuantity ?? 0)}
      </Box>
    )
  },
  {
    accessorKey: "actualQuantity",
    header: "Actual Qty",
    enableColumnFilter: false,
    enableSorting: false,
    cell: ({ row }) => (
      <Box textAlign="right" fontWeight="medium">
        {getDisplayPrice(row.original.actualQuantity ?? 0)}
      </Box>
    )
  },
  {
    accessorKey: "variance",
    header: "Variance",
    enableColumnFilter: false,
    enableSorting: false,
    cell: ({ row }) => {
      const expected = row.original.expectedQuantity ?? 0
      const actual = row.original.actualQuantity ?? 0
      const variance = actual - expected

      return (
        <Box
          textAlign="right"
          fontWeight="medium"
          color={variance === 0 ? "success.main" : variance > 0 ? "info.main" : "error.main"}
        >
          {variance > 0 ? "+" : ""}
          {getDisplayPrice(variance)}
        </Box>
      )
    }
  },
  {
    accessorKey: "lotStockValue",
    header: "Stock Value",
    enableColumnFilter: false,
    enableSorting: false,
    cell: ({ row }) => (
      <Box textAlign="right" fontWeight="medium">
        {getDisplayPrice(row.original.lotStockValue ?? 0, "PKR ")}
      </Box>
    )
  }
]
